import { useState } from 'react';
import { PortalPartnerAccount, PortalPartnerAccountsRequest } from 'vopay';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useFetchPortalPartnerAccounts() {
  const [fetching, setFetching] = useState(false);
  const [accounts, setAccounts] = useState<PortalPartnerAccount[]>([]);

  async function fetchPortalPartnerAccounts(params: PortalPartnerAccountsRequest) {
    try {
      setFetching(true);
      const data = await api.fetchPortalPartnerAccounts(params);

      if (!data.Success) {
        throw new Error(data.ErrorMessage);
      }

      setAccounts(data.Accounts || []);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return {
    fetching,
    accounts,
    fetchPortalPartnerAccounts,
  };
}
